var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CButton',_vm._b({staticClass:"p-1 px-2",attrs:{"color":_vm.color,"variant":"outline"},on:{"click":_vm.download_csv}},'CButton',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }